<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';
    import FormSelect from '@/components/Form/Select/Select.vue';
    
    export default {
        FormSelect,
        StaticMultiSelect: defineAsyncComponent(() => import('@/components/Form/Select/MultiStatic.vue')),
    }
</script>